import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStarGlowingLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "star glowing",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		opacity: .4,
		d: "M9.93143 3.28833C10.9621 6.67481 13.6123 9.32511 16.9986 10.3558C13.6123 11.3866 10.9621 14.0369 9.93143 17.4234C8.90075 14.0369 6.25058 11.3866 2.86426 10.3558C6.25058 9.32511 8.90075 6.67481 9.93143 3.28833Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M18.0714 14.1255C18.5516 15.7034 19.7864 16.9383 21.3643 17.4185C19.7864 17.8988 18.5516 19.1336 18.0714 20.7115C17.5912 19.1336 16.3563 17.8988 14.7785 17.4185C16.3563 16.9383 17.5912 15.7034 18.0714 14.1255Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgStarGlowingLine;
